import { createRequestActions, RequestType } from 'store/utils';
import { ISetDealStatusPayload } from 'modules/settings/submodules/clients/deals/components/UpdateStatusSelect/store/models';
import { IDeal } from 'shared/models/Deal';

export const setDealStatus = createRequestActions<ISetDealStatusPayload, IDeal>(
    RequestType.PATCH,
    'DEAL_STATUS',
    'settings/');
